module.exports = __webpack_public_path__ + "img/google.f457135d.png";